// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React, { useState } from "react";
import { connect } from "react-redux";

import type { State } from "src/types";

import { VStack, HStack, Button, Box } from "@chakra-ui/react";

import RecipientType from "./Type";
import * as styles from "../styles";

type Props = {
  ccLength: number,
  bccLength: number,
};

function Recipients({ ccLength, bccLength }: Props) {
  const [showCc, setShowCc] = useState(ccLength > 0);
  const [showBcc, setShowBcc] = useState(bccLength > 0);

  return (
    <VStack alignItems="start" width="100%">
      <Box {...styles.formItemFrame}>
        <HStack width="100%" alignItems="start">
          <RecipientType recipientType="to" label="To" />

          <HStack>
            {!showCc && (
              <Button
                {...styles.unstyledButtonLink}
                onClick={() => setShowCc(true)}
              >
                {i18n.t(k.CC)}
              </Button>
            )}

            {!showBcc && (
              <Button
                {...styles.unstyledButtonLink}
                onClick={() => setShowBcc(true)}
              >
                {i18n.t(k.BCC)}
              </Button>
            )}
          </HStack>
        </HStack>
      </Box>

      {showCc && (
        <Box {...styles.formItemFrame}>
          <RecipientType recipientType="cc" label="Cc" />
        </Box>
      )}

      {showBcc && (
        <Box {...styles.formItemFrame}>
          <RecipientType recipientType="bcc" label="Bcc" />
        </Box>
      )}
    </VStack>
  );
}

const mapStateToProps = ({ app }: State) => ({
  ccLength: app.email.data.cc.length,
  bccLength: app.email.data.bcc.length,
});

export default connect(mapStateToProps, null)(Recipients);
